if(document.querySelector('.lottie-animation')) {
    import(
        /* webpackChunkName: "lottie" */
        /* webpackMode: "lazy" */
        './lottie'
    );
}
